<template>
  <div class="text-dark pad-1">
    <div class="page-header marg-1-bottom">
      <h2>Ansættelser</h2>
      <button class="do-bttn"
              v-if="isOrganisationsEnabled"
              @click="isOrganisationsModal = true">
        Organisationer
      </button>
    </div>
    <SalarySettingsUsersOpus
      :isSalaryIntegrationActive="true"
      :users="usersWithEmployments"
      :employments="employments"
      :tags="tags"
      :isShowEmploymentNumber="true"
      :confirmRemoveTemplateOnTagClick="true"
      filtersStorageKey="tjenestenumreFilters"
      rowActionLabel="Indtast tjenestenummer"
      :emitEditSsn="true"
      @setTheEditUser="openImport"
      @editSsn="openImport"
    ></SalarySettingsUsersOpus>

    <EmploymentImportModal
      v-if="theImportUser"
      :user="theImportUser"
      numberLabel="Tjenestenummer"
      :maxLength="5"
      @close="theImportUser = null"
    ></EmploymentImportModal>

    <SalaryOrganisationsModal
      v-if="isOrganisationsModal"
      @close="isOrganisationsModal = false"
    ></SalaryOrganisationsModal>
  </div>
</template>

<script>
import SalarySettingsUsersOpus from '../SalarySettings/SalarySettingsUsersOpus.vue'
import EmploymentImportModal from '../SalarySettings/EmploymentImportModal.vue'
import SalaryOrganisationsModal from '../SalarySettings/SalaryOrganisationsModal.vue'

export default {
  components: {
    SalarySettingsUsersOpus,
    EmploymentImportModal,
    SalaryOrganisationsModal
  },
  data () {
    return {
      theImportUser: null,
      isOrganisationsModal: false
    }
  },
  methods: {
    // Modalen håndterer selv manglende CPR - så indtastes CPR og tjenestenummer samtidig.
    openImport (user) {
      if (user) {
        this.theImportUser = user
      }
    }
  },
  computed: {
    // Kun for docendo-admins
    isOrganisationsEnabled () {
      const user = this.$store.state.user
      if (!user || !user.admin) {
        return false
      }
      return true
    },
    users () {
      return this.$store.getters.usersSortedOnName
    },
    employments () {
      const all = this.$store.state.employments && this.$store.state.employments.employments
        ? this.$store.state.employments.employments
        : []
      return all.filter(employment => !employment.deleted)
    },
    employmentsInUserIdHash () {
      return this.$store.getters.employmentsInUserIdHash
    },
    usersWithEmployments () {
      return this.users.map(user => {
        const userEmployments = this.employmentsInUserIdHash[user.id] ? this.employmentsInUserIdHash[user.id] : []
        const employmentsSorted = userEmployments
          .filter(employment => !employment.deleted)
          .sort((a, b) => {
            const aTitle = a && (a.source_title || a.title) ? (a.source_title || a.title) : ''
            const bTitle = b && (b.source_title || b.title) ? (b.source_title || b.title) : ''
            return aTitle.localeCompare(bTitle, 'da-DK')
          })
        return {
          ...user,
          v_employments: employmentsSorted
        }
      })
    },
    tags () {
      const tagSet = new Set()
      this.users.forEach(user => {
        if (user.user_tags && Array.isArray(user.user_tags)) {
          user.user_tags.forEach(tag => tagSet.add(tag))
        }
      })
      return Array.from(tagSet).sort((a, b) => a.localeCompare(b, 'da-DK'))
    }
  },
  mounted () {
    this.$store.dispatch('getUsersFromSchoolId', this.$store.getters.schoolId)
    this.$store.dispatch('readEmployments')
  }
}
</script>

<style scoped>
.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.page-header h2 {
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// Tjenestenumre.vue?3c74e9f4